import useAnimatedStars from './useAnimatedStars.hook';
import { StyledAnimatedStars, StyledStar } from './AnimatedStars.styled';
import { useRef } from 'react';
import { ANCHOR } from '@/modules/dom/getElementCoordinates';

export default function AnimatedStars({
  originSelector,
  originAnchor = ANCHOR.CENTER,
  iframeStarsOrigin,
}) {
  const starsRef = useRef([]);
  const { state } = useAnimatedStars({
    starsRef,
    originSelector,
    originAnchor,
    iframeStarsOrigin,
  });
  return (
    <StyledAnimatedStars>
      {Array(3)
        .fill()
        .map((_, index) => (
          <Star
            starRef={(ref) => (starsRef.current[index] = ref)}
            key={index}
            index={index}
            animating={state.animating}
          />
        ))}
    </StyledAnimatedStars>
  );
}
function Star({ animating, starRef }) {
  return (
    <StyledStar ref={starRef} animating={animating}>
      ⭐
    </StyledStar>
  );
}
